import { gatherMultiLevelSelectInitialValues } from '../../../../../../components/MultiLevelSelect/formatters'

import { INTERESTS } from '../../../../../ReusableFormFields/InterestsFields/fields'
import { INTEREST_KEYWORD_IDS } from '../../../../UploadTikTokAdCreative/UploadTikTokAdCreativeForm/LineItemForm/Steps/CustomAudiencesStep/TikTokUploadCreativeAudienceFields/TikTokAdvancedAudienceTargetingSection/AdditionalInterestCategoriesMultiselect'
import { PURCHASE_INTENTION_KEYWORD_IDS } from '../../../../UploadTikTokAdCreative/UploadTikTokAdCreativeForm/LineItemForm/Steps/CustomAudiencesStep/TikTokUploadCreativeAudienceFields/TikTokAdvancedAudienceTargetingSection/PurchaseIntentionCategoriesMultiselect'

export const formatValuesToFE = ({
  lineItem = {},
  interestOptions,
  additionalInterestCategoriesByIds,
  purchaseIntentionCategoriesByIds
}) => {
  const { interest_category: interestIds } = lineItem

  return {
    [INTERESTS]: (interestIds && gatherMultiLevelSelectInitialValues(interestIds, interestOptions)) || [],
    [INTEREST_KEYWORD_IDS]: lineItem[INTEREST_KEYWORD_IDS]
      ? lineItem[INTEREST_KEYWORD_IDS].map(item => {
          const foundItem = additionalInterestCategoriesByIds.find(
            additionalInterest => additionalInterest.keyword_id === item
          )

          return {
            ...(foundItem ? foundItem : {}),
            value: foundItem?.keyword_id,
            label: foundItem?.keyword
          }
        })
      : [],

    [PURCHASE_INTENTION_KEYWORD_IDS]: lineItem[PURCHASE_INTENTION_KEYWORD_IDS]
      ? lineItem[PURCHASE_INTENTION_KEYWORD_IDS].map(item => {
          const foundItem = purchaseIntentionCategoriesByIds.find(
            purchaseIntention => purchaseIntention.keyword_id === item
          )

          return {
            ...(foundItem ? foundItem : {}),
            value: foundItem?.keyword_id,
            label: foundItem?.keyword
          }
        })
      : []
  }
}
